import { call, put, select, takeEvery, all } from 'redux-saga/effects'
import { notification } from 'antd'
import * as api from './api'
import * as actions from './actions'
import * as selectors from './selectors'

function* fetchPromotionsWorker({ payload = {} }) {
  try {
    yield put(actions.setLoading())

    const perPage = yield select(selectors.getPerPage)
    const currentStatus = yield select(selectors.getStatus)
    const { page = 1, status = currentStatus } = payload

    yield put(actions.saveFilters({ page, status }))

    const response = yield call(api.listPromotions, { status, page, perPage })
    const body = response?.data
    const data = Array.isArray(body) ? body : body?.data || []
    let total
    if (data.length < perPage) {
      total = (page - 1) * perPage + data.length
    } else {
      total = page * perPage + 1
    }

    yield put(actions.fetchPromotionsSuccess({ data, total, page }))
  } catch (error) {
    yield put(actions.fetchPromotionsFailure())
  }
}

function* fetchPromotionWorker({ payload }) {
  try {
    const response = yield call(api.getPromotion, payload.id)
    yield put(actions.setCurrentPromotion(response?.data || null))
  } catch (error) {
    // already notified by parseError
  }
}

function* refetchList() {
  const page = yield select(selectors.getPage)
  const status = yield select(selectors.getStatus)
  yield put(actions.fetchPromotions({ page, status }))
}

function* createPromotionWorker({ payload }) {
  try {
    yield put(actions.setSubmitting(true))
    yield call(api.createPromotion, payload.values)
    notification.success({ message: 'Promotion created' })
    if (payload.callback) payload.callback()
    yield* refetchList()
  } catch (error) {
    // notification handled by parseError
  } finally {
    yield put(actions.setSubmitting(false))
  }
}

function* updatePromotionWorker({ payload }) {
  try {
    yield put(actions.setSubmitting(true))
    yield call(api.updatePromotion, payload.id, payload.values)
    notification.success({ message: 'Promotion updated' })
    if (payload.callback) payload.callback()
    yield* refetchList()
  } catch (error) {
    // notification handled by parseError
  } finally {
    yield put(actions.setSubmitting(false))
  }
}

function* runStatusAction({ payload }, apiFn, successMessage) {
  try {
    yield put(actions.setSubmitting(true))
    yield call(apiFn, payload.id)
    notification.success({ message: successMessage })
    if (payload.callback) payload.callback()
    yield* refetchList()
  } catch (error) {
    // notification handled by parseError
  } finally {
    yield put(actions.setSubmitting(false))
  }
}

function* activateWorker(action) {
  yield* runStatusAction(action, api.activatePromotion, 'Promotion activated')
}

function* deactivateWorker(action) {
  yield* runStatusAction(action, api.deactivatePromotion, 'Promotion deactivated')
}

function* cancelWorker(action) {
  yield* runStatusAction(action, api.cancelPromotion, 'Promotion cancelled')
}

export default function* surpriseBoxSaga() {
  yield all([
    takeEvery(actions.fetchPromotions.type, fetchPromotionsWorker),
    takeEvery(actions.fetchPromotion.type, fetchPromotionWorker),
    takeEvery(actions.createPromotion.type, createPromotionWorker),
    takeEvery(actions.updatePromotion.type, updatePromotionWorker),
    takeEvery(actions.activatePromotion.type, activateWorker),
    takeEvery(actions.deactivatePromotion.type, deactivateWorker),
    takeEvery(actions.cancelPromotion.type, cancelWorker),
  ])
}
